import { StyleSheet } from 'react-native';
import {
  darkestGrey,
  purple,
  buttonBorderRadius,
  white,
  fontSizeMedium,
  fontFamilyLight,
  grey,
  buttonPadding,
  fontFamilyRegular,
} from '../../../constants/palette';

export default StyleSheet.create({
  container: {},
  disabledButtonStyle: {
    minWidth: 20,
    margin: 3,
    padding: buttonPadding,
    backgroundColor: grey,
    borderRadius: buttonBorderRadius,
    alignSelf: 'center',
  },
  activeButtonStyle: {
    minWidth: 20,
    margin: 3,
    padding: buttonPadding,
    backgroundColor: purple,
    borderRadius: buttonBorderRadius,
    alignSelf: 'center',
  },
  unSelectedButtonStyle: {
    minWidth: 20,
    margin: 3,
    padding: buttonPadding,
    backgroundColor: darkestGrey,
    borderRadius: buttonBorderRadius,
    alignSelf: 'center',
  },
  text: {
    color: white,
    fontSize: fontSizeMedium,
    alignSelf: 'center',
  },
});
